import { render, staticRenderFns } from "./AccHistory.vue?vue&type=template&id=3489efb7&scoped=true&"
import script from "./AccHistory.vue?vue&type=script&lang=js&"
export * from "./AccHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489efb7",
  null
  
)

export default component.exports